module.exports = {
   baseUrl: '//artguide.artforum.com',
   webroot: '',
   imageBasePath: '//artguide.artforum.com',
   bookforumUrl: '//www.bookforum.com',
   ADMIN_ARTGUIDE_APPKEY: '772ztyfstfdwvDSM23WqaS098hkLszxiO09oiujdFG341lk8'
};
